/** Body of POST /v1/feedback, the thumbs under an agent's answer. */
export interface FeedbackRequestBody {
  message_id: string
  agent_id?: string
  execution_id?: string
  feedback_type: 'thumbs_up' | 'thumbs_down'
}

/**
 * Builds the rating of one answer. The run (execution_id) is what lets
 * governance move the rated agent's trust: it checks that the person can view
 * the run and that the agent took part in it (agion/Agion#2604).
 */
export function buildFeedbackRequest(
  messageId: string,
  agentId: string | undefined,
  executionId: string | null | undefined,
  type: 'positive' | 'negative',
): FeedbackRequestBody {
  const body: FeedbackRequestBody = {
    message_id: messageId,
    feedback_type: type === 'positive' ? 'thumbs_up' : 'thumbs_down',
  }
  if (agentId) body.agent_id = agentId
  if (executionId) body.execution_id = executionId
  return body
}
